import moment from 'moment-timezone'
import api from '@/services/api'

const TIMEZONE = 'Asia/Bangkok'
const isMigrated = true

function buildEventActivityItems (activityList, eventList) {
  console.log('process.env', process.env)
  // build event activity list
  const eventActivityHomeList = {}
  // sort activity
  activityList.forEach((act) => {
    let pubDate = null
    if (isMigrated) {
      pubDate = moment(act.publish_date).tz(TIMEZONE)
    } else {
      pubDate = moment(act.PublishDate).tz(TIMEZONE)
    }
    const pubKey = pubDate.format('X')
    if (typeof eventActivityHomeList[pubKey] === 'undefined') {
      eventActivityHomeList[pubKey] = []
    }
    if (isMigrated) {
      eventActivityHomeList[pubKey].push({
        type: 'activity',
        id: act.id,
        name: act.title,
        startDate: pubDate,
        endDate: null,
        publishDate: act.publish_date,
        image_url: act.image_url,
        link_to: act.link_to
      })
    } else {
      eventActivityHomeList[pubKey].push({
        type: 'activity',
        id: act.Id,
        name: act.Title,
        startDate: pubDate,
        endDate: null,
        publishDate: act.PublishDate,
        link_to: act.link_to
      })
    }
  })
  // sort event
  eventList.forEach((evt) => {
    let startDate = null
    let endDate = null
    if (isMigrated) {
      startDate = moment(evt.start_date).tz(TIMEZONE)
      endDate = moment(evt.end_date).tz(TIMEZONE)
    } else {
      startDate = moment(evt.StartDate).tz(TIMEZONE)
      endDate = moment(evt.EndDate).tz(TIMEZONE)
    }
    const pubKey = startDate.format('X')
    if (typeof eventActivityHomeList[pubKey] === 'undefined') {
      eventActivityHomeList[pubKey] = []
    }
    if (isMigrated) {
      eventActivityHomeList[pubKey].push({
        type: 'event',
        id: evt.id,
        // name: evt.name,
        name: evt.title,
        startDate,
        endDate,
        publishDate: evt.publish_date,
        image_url: evt.image_url,
        link_to: evt.link_to
      })
    } else {
      eventActivityHomeList[pubKey].push({
        type: 'event',
        id: evt.Id,
        // name: evt.Name,
        name: evt.Name,
        startDate,
        endDate,
        publishDate: evt.PublishDate,
        link_to: evt.link_to
      })
    }
  })
  // console.log('eventActivityHomeList', eventActivityHomeList)
  const combinedList = []
  Object.keys(eventActivityHomeList)
    .sort()
    .reverse()
    .forEach((key) => {
      eventActivityHomeList[key].forEach(item => combinedList.push(item))
    })
  return combinedList
}

export const state = () => ({
  heroBannerList: [],
  activityList: [],
  activityListQuery: {
    page: 1,
    size: 24
  },
  activityPastList: [],
  activityPastListQuery: {
    page: 1,
    size: 24
  },
  activityHomeList: [],
  activityBannerList: [],
  eventList: [],
  eventListQuery: {
    page: 1,
    size: 24
  },
  eventPastList: [],
  eventPastListQuery: {
    page: 1,
    size: 24
  },
  eventHomeList: [],
  eventBannerList: [],
  eventActivityList: [],
  eventActivityPastList: [],
  eventActivityBannerList: [],
  eventActivityHomeList: [],
  eventActivityInfo: null,
  popupList: []
})
export const getters = {
  heroBannerList (state) {
    return state.heroBannerList
  },
  activityList (state) {
    return state.activityList
  },
  activityListQuery (state) {
    return state.activityListQuery
  },
  activityPastList (state) {
    return state.activityPastList
  },
  activityPastListQuery (state) {
    return state.activityPastListQuery
  },
  activityHomeList (state) {
    return state.activityHomeList
  },
  activityBannerList (state) {
    return state.activityBannerList
  },
  eventList (state) {
    return state.eventList
  },
  eventPastList (state) {
    return state.eventPastList
  },
  eventHomeList (state) {
    return state.eventHomeList
  },
  eventBannerList (state) {
    return state.eventBannerList
  },
  eventActivityBannerList (state) {
    return state.eventActivityBannerList
  },
  eventActivityHomeList (state) {
    return state.eventActivityHomeList
  },
  eventActivityInfo (state) {
    return state.eventActivityInfo
  },
  eventActivityList (state) {
    return state.eventActivityList
  },
  eventActivityPastList (state) {
    return state.eventActivityPastList
  },
  popupList (state) {
    return state.popupList
  }
}
export const actions = {
  GET_HERO_BANNER_LIST ({ commit }) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getHeroBannerList()
        .then((result) => {
          commit('GET_HERO_BANNER_LIST_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_POPUP_BANNER_LIST ({ commit }) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getPopupList()
        .then((result) => {
          commit('GET_POPUP_BANNER_LIST_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_ACTIVITY_LIST ({ commit }, query) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getActivities(query)
        .then((result) => {
          commit('GET_ACTIVITY_LIST_SUCCESS', {
            result,
            query
          })
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_ACTIVITY_PAST_LIST ({ commit }, query) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getActivities(query)
        .then((result) => {
          commit('GET_ACTIVITY_PAST_LIST_SUCCESS', {
            result,
            query
          })
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_ACTIVITY_HOME_LIST ({ commit }) {
    const publishDate = moment().tz(TIMEZONE)
    return new Promise((resolve, reject) => {
      const fromPublishDate = publishDate.clone().add(-1, 'month').startOf('month')
      const toPublishDate = publishDate.clone().add(1, 'month').endOf('month')
      const query = {
        is_home: true,
        to_publish_date: encodeURIComponent(toPublishDate.format('YYYY-MM-DD')),
        from_publish_date: encodeURIComponent(fromPublishDate.format('YYYY-MM-DD'))
      }
      api(this.app.context)
        .getActivities(query)
        .then((result) => {
          commit('GET_ACTIVITY_HOME_LIST_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_ACTIVITY_BANNER_LIST ({ commit }) {
    return new Promise((resolve, reject) => {
      const query = {
        is_banner: true
      }
      api(this.app.context)
        .getActivities(query)
        .then((result) => {
          commit('GET_ACTIVITY_BANNER_LIST_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_EVENT_LIST ({ commit }, query) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getEvents(query)
        .then((result) => {
          commit('GET_EVENT_LIST_SUCCESS', {
            result,
            query
          })
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_EVENT_PAST_LIST ({ commit }, query) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getEvents(query)
        .then((result) => {
          commit('GET_EVENT_PAST_LIST_SUCCESS', {
            result,
            query
          })
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_EVENT_HOME_LIST ({ commit }) {
    const startDate = moment()
      .tz(TIMEZONE)
      .add(-1, 'month')
      .startOf('month')
    const endDate = moment()
      .tz(TIMEZONE)
      .day(1)
      .hour(0)
      .minute(0)
      .second(0)
      .add(1, 'month')
      .endOf('month')
    return new Promise((resolve, reject) => {
      const query = {
        is_home: true,
        from_end_date: encodeURIComponent(startDate.format('YYYY-MM-DD')),
        to_end_date: encodeURIComponent(endDate.format('YYYY-MM-DD'))
        // to_end_date: encodeURIComponent(startDate.format())
      }
      api(this.app.context)
        .getEvents(query)
        .then((result) => {
          commit('GET_EVENT_HOME_LIST_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_EVENT_BANNER_LIST ({ commit }) {
    return new Promise((resolve, reject) => {
      const query = {
        is_banner: true
      }
      api(this.app.context)
        .getEvents(query)
        .then((result) => {
          commit('GET_EVENT_BANNER_LIST_SUCCESS', result)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_ACTIVITY_INFO ({ commit }, id) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getActivity(id)
        .then((result) => {
          commit('GET_EVENT_ACTIVITY_INFO_SUCCESS', {
            type: 'activity',
            info: result
          })
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_EVENT_INFO ({ commit }, id) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getEvent(id)
        .then((result) => {
          commit('GET_EVENT_ACTIVITY_INFO_SUCCESS', {
            type: 'event',
            info: result
          })
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  }
}
export const mutations = {
  GET_HERO_BANNER_LIST_SUCCESS (state, list) {
    state.heroBannerList = list
  },
  GET_POPUP_BANNER_LIST_SUCCESS (state, list) {
    state.popupList = list
  },
  GET_ACTIVITY_LIST_SUCCESS (state, { result, query }) {
    const list = result.results
    /* let list = []
    if (result.Records) {
      list = result.Records
    } else if (result.records) {
      list = result.records
    } */
    state.activityList = list
    state.activityListQuery = query
    state.eventActivityList = buildEventActivityItems(state.activityList, state.eventList)
  },
  GET_ACTIVITY_PAST_LIST_SUCCESS (state, { result, query }) {
    const list = result.results
    state.activityPastList = list
    state.activityPastListQuery = query
    state.eventActivityPastList = buildEventActivityItems(state.activityPastList, state.eventPastList)
  },
  GET_ACTIVITY_HOME_LIST_SUCCESS (state, result) {
    const list = result.results
    /* let list = []
    if (result.Records) {
      list = result.Records
    } else if (result.records) {
      list = result.records
    } */
    state.activityHomeList = list
    state.eventActivityHomeList = buildEventActivityItems(state.activityHomeList, state.eventHomeList)
  },
  GET_ACTIVITY_BANNER_LIST_SUCCESS (state, result) {
    /* let list = []
    if (result.Records) {
      list = result.Records
    } else if (result.records) {
      list = result.records
    } */
    const list = result.results
    state.activityBannerList = list
    state.eventActivityBannerList = buildEventActivityItems(state.activityBannerList, state.eventBannerList)
  },
  GET_EVENT_LIST_SUCCESS (state, { result, query }) {
    /* let list = []
    if (result.Records) {
      list = result.Records
    } else if (result.records) {
      list = result.records
    } */
    const list = result.results
    state.eventList = list
    state.eventListQuery = query
    state.eventActivityList = buildEventActivityItems(state.activityList, state.eventList)
  },
  GET_EVENT_PAST_LIST_SUCCESS (state, { result, query }) {
    console.log('GET_EVENT_PAST_LIST_SUCCESS', result)
    const list = result.results
    state.eventPastList = list
    state.eventPastListQuery = query
    state.eventActivityPastList = buildEventActivityItems(state.activityPastList, state.eventPastList)
  },
  GET_EVENT_HOME_LIST_SUCCESS (state, result) {
    /* let list = []
    if (result.Records) {
      list = result.Records
    } else if (result.records) {
      list = result.records
    } */
    const list = result.results
    state.eventHomeList = list
    state.eventActivityHomeList = buildEventActivityItems(state.activityHomeList, state.eventHomeList)
  },
  GET_EVENT_BANNER_LIST_SUCCESS (state, result) {
    /* let list = []
    if (result.Records) {
      list = result.Records
    } else if (result.records) {
      list = result.records
    } */
    const list = result.results
    state.eventBannerList = list
    state.eventActivityBannerList = buildEventActivityItems(state.activityBannerList, state.eventBannerList)
  },
  GET_EVENT_ACTIVITY_INFO_SUCCESS (state, eventActivityInfo) {
    state.eventActivityInfo = eventActivityInfo
  }
}
